import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Wrapper from "./components/wrapper";
import React, { useEffect, useState } from "react";
import BarbaWrapper from "./components/barbawrapper";
import Lenis from "@studio-freight/lenis";
import { useCanvas } from "./components/canvas";
import { createWeb3Modal } from "@web3modal/wagmi/react";
import { defaultWagmiConfig } from "@web3modal/wagmi/react/config";
import { WagmiProvider } from "wagmi";
import { mainnet, sepolia } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

const metadata = {
  name: "BasedAI Brain Mint",
  description: "Brain Mint Interface",
  url: "https://getbased.ai",
  icons: ["https://www.pepecoin.io/android-chrome-512x512.png"],
};

const chains = [mainnet, sepolia];
const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  auth: {
    email: false,
    socials: false,
  },
});

createWeb3Modal({
  wagmiConfig: config,
  projectId,
  enableAnalytics: false,
  themeMode: "dark",
  // TODO: switch for mainnet
  activeChain: mainnet,
  enableSwaps: false,
  enableOnramp: false,
  // tokens: {
  //   11155111: {
  //     address: process.env.REACT_APP_PEPECOIN_CONTRACT,
  //   },
  //   11155111: {
  //     address: process.env.REACT_APP_BRAIN_CREDITS,
  //   },
  // },
});

function App() {
  const { camera, flags } = useCanvas();

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.5,
      wheelMultiplier: 0.7,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      // Cleanup function to stop animation loop
      lenis.stop();
    };
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoaded(true);
    }, 200);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (isLoaded) {
      document.body.classList.add("website-loaded");
    }
  }, [isLoaded]);

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <BarbaWrapper camera={camera} flags={flags}>
            <Wrapper />
          </BarbaWrapper>
        </Router>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
